import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import { toast } from "react-toastify";

import Navbar from "../../Components/Common/Navbar";
import PageWrapper from "../../Components/Common/PageWrapper";
import "../../Stylesheets/Auth/SignIn.css"; // ✅ same shared styles

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Email is required");
      return;
    }

    setSubmitting(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
      toast.success("Reset link sent! Check your email.");
    } catch (err) {
      toast.error(err?.message || "Failed to send reset link");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="auth-page-bg">
        <PageWrapper>
          <div className="auth-wrap">
            <div className="auth-card">
              <div className="auth-head">
                <h2 className="auth-title">Reset your password</h2>
                <p className="auth-subtitle">
                  Enter your email and we’ll send you a secure reset link.
                </p>
              </div>

              {!sent ? (
                <form className="auth-form" onSubmit={handleSubmit}>
                  <div className="auth-field">
                    <label className="auth-label">Email</label>
                    <input
                      type="email"
                      className="auth-input"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                    />
                  </div>

                  <button type="submit" className="auth-submit" disabled={submitting}>
                    {submitting ? "Sending..." : "Send Reset Link"}
                  </button>

                  <p className="auth-foot" style={{ marginTop: 14 }}>
                    Remembered your password? <a href="/signin">Sign in</a>
                  </p>
                </form>
              ) : (
                <div className="auth-form">
                  <div className="auth-success">
                    <div className="auth-success-icon">✅</div>
                    <div>
                      <div className="auth-success-title">Check your inbox</div>
                      <div className="auth-success-desc">
                        If an account exists for <b>{email}</b>, you’ll get a reset link within a minute.
                        Check spam/promotions too.
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="auth-google"
                    onClick={() => {
                      setSent(false);
                      setEmail("");
                    }}
                  >
                    Send to another email
                  </button>

                  <p className="auth-foot" style={{ marginTop: 14 }}>
                    Back to <a href="/signin">Sign in</a>
                  </p>
                </div>
              )}
            </div>
          </div>
        </PageWrapper>
      </div>
    </>
  );
};

export default ForgotPassword;
